import { GOST_7_32 } from './ids';
import type { Profile } from './types';

/**
 * ГОСТ 7.32-2017 «Отчёт о научно-исследовательской работе. Структура и правила оформления».
 * На него ссылается большинство вузовских методичек для курсовых и ВКР.
 *
 * Выравнивание по ширине и нулевые интервалы между абзацами стандартом не
 * регламентированы, но их требует почти каждая методичка, поэтому они
 * проверяются с важностью «совет».
 */
export const GOST_7_32_2017: Profile = {
  id: GOST_7_32,
  name: 'ГОСТ 7.32-2017',
  description: 'Отчёт о НИР: курсовые, ВКР, отчёты о практике',
  page: {
    widthMm: 210,
    heightMm: 297,
    margins: { top: 20, bottom: 20, left: 30, right: 15 },
    toleranceMm: 1,
  },
  pageNumbers: { position: 'bottom', align: 'center', hideOnTitle: true },
  text: {
    fonts: ['Times New Roman'],
    minSizePt: 12,
    lineSpacing: 1.5,
    firstLineIndentCm: 1.25,
    alignment: 'justify',
    spacingBeforePt: 0,
    spacingAfterPt: 0,
  },
  headings: {
    structuralCase: 'upper',
    structuralBold: true,
    sectionAlign: 'indent',
    sectionBold: true,
    numberDot: false,
    newPage: true,
    required: ['contents', 'intro', 'conclusion', 'references'],
    contentsMinPages: 10,
    tocDepth: 2,
    names: {
      contents: 'СОДЕРЖАНИЕ',
      conclusion: 'ЗАКЛЮЧЕНИЕ',
      references: 'СПИСОК ИСПОЛЬЗОВАННЫХ ИСТОЧНИКОВ',
      abbreviations: 'ПЕРЕЧЕНЬ СОКРАЩЕНИЙ И ОБОЗНАЧЕНИЙ',
    },
    order: [
      ['executors'],
      ['abstract', 'annotation', 'preface'],
      ['contents'],
      ['terms'],
      ['abbreviations'],
      ['intro'],
      ['conclusion'],
      ['references'],
      ['appendix'],
    ],
  },
  captions: { dashes: ['—', '–'], numbering: 'any' },
  references: { order: 'appearance' },
  // Требования ЕСКД, которых в ГОСТ 7.32 нет; методичка может их включить.
  rules: {
    'structure.appendix-status': 'off',
    'structure.heading-size': 'off',
    'objects.table-number-column': 'off',
    'text.signs': 'off',
  },
};
